(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-sec"] && !Shopify.designMode) return;
  try {
    
  (function(){
    'use strict';

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    function ease(t){ return 1 - Math.pow(1 - t, 3); }

    function parseTarget(raw){
      if (raw === null || raw === undefined) return 0;
      var digits = String(raw).replace(/[^0-9.-]/g, '');
      if (digits === '' || digits === '-' || digits === '.') return 0;
      var n = parseFloat(digits);
      return isNaN(n) ? 0 : n;
    }

    function format(n, target, plain){
      var isInt = Number.isInteger(target);
      if (isInt){
        var r = Math.round(n);
        return plain ? String(r) : r.toLocaleString();
      }
      return n.toFixed(1);
    }

    function animateCounter(el){
      var target = parseTarget(el.getAttribute('data-aa-target'));
      var prefix = el.getAttribute('data-aa-prefix') || '';
      var suffix = el.getAttribute('data-aa-suffix') || '';
      var dur = parseInt(el.getAttribute('data-aa-duration'), 10) || 1800;
      var plain = el.getAttribute('data-aa-plain') === 'true';

      if (reduced){
        el.textContent = prefix + format(target, target, plain) + suffix;
        return;
      }

      var start = null;
      function step(ts){
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = prefix + format(target * ease(p), target, plain) + suffix;
        if (p < 1){
          window.requestAnimationFrame(step);
        } else {
          el.textContent = prefix + format(target, target, plain) + suffix;
        }
      }
      window.requestAnimationFrame(step);
    }

    function initReveals(root){
      var els = root.querySelectorAll('[data-aa-reveal]');
      if (!els.length) return;
      if (reduced || !hasIO){
        els.forEach(function(el){ el.classList.add('is-inview'); });
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            e.target.classList.add('is-inview');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      els.forEach(function(el){ io.observe(el); });
    }

    function initCounters(root){
      var counters = root.querySelectorAll('[data-aa-counter]');
      if (!counters.length) return;
      if (!hasIO){
        counters.forEach(animateCounter);
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            animateCounter(e.target);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      counters.forEach(function(el){ io.observe(el); });
    }

    function initSection(root){
      if (!root) return;
      initReveals(root);
      initCounters(root);
    }

    function bootAll(){
      document.querySelectorAll('[data-section-type="about-acoem"]').forEach(initSection);
    }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

    document.addEventListener('shopify:section:load', function(e){
      if (!e.target) return;
      var sec = e.target.matches && e.target.matches('[data-section-type="about-acoem"]')
        ? e.target
        : e.target.querySelector && e.target.querySelector('[data-section-type="about-acoem"]');
      if (sec) initSection(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dodge-seo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dodge-seo-section')) {
  class DodgeSeoSection extends HTMLElement {
    #observer = null;

    connectedCallback() {
      const root = this.closest('.dseo') || this;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduce || !('IntersectionObserver' in window)) {
        root.classList.add('dseo--no-motion');
        for (const el of this.querySelectorAll('[data-reveal]')) el.classList.add('is-in');
        return;
      }

      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-in');
            this.#observer.unobserve(entry.target);
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
      );

      for (const el of this.querySelectorAll('[data-reveal]')) this.#observer.observe(el);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }
  }

  customElements.define('dodge-seo-section', DodgeSeoSection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0;

  function initReveal(root) {
    if (root.dataset.reveal !== 'true') return;
    var cols = root.querySelectorAll('.fc-col');
    if (!('IntersectionObserver' in window) || prefersReduced) {
      cols.forEach(function (c) { c.dataset.revealed = 'true'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.dataset.revealed = 'true';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    cols.forEach(function (c) { io.observe(c); });
  }

  function initTilt(root) {
    if (root.dataset.effect !== 'tilt' || prefersReduced || isTouch) return;
    var cards = root.querySelectorAll('.fc-card');
    cards.forEach(function (card) {
      if (card.__fcTilt) return;
      card.__fcTilt = true;
      var raf = null;

      function onMove(e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var x = (px - 0.5) * 2;
        var y = (py - 0.5) * 2;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform =
            'perspective(800px) rotateY(' + (x * 5).toFixed(2) +
            'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg)';
        });
      }
      function onLeave() {
        if (raf) cancelAnimationFrame(raf);
        card.style.transform = '';
      }

      card.addEventListener('mousemove', onMove);
      card.addEventListener('mouseleave', onLeave);
    });
  }

  function initSection(root) {
    if (!root) return;
    initReveal(root);
    initTilt(root);
  }

  function initAll() {
    document.querySelectorAll('.fc[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor live updates
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.fc[data-section-id]') : null;
    if (!root && e.target.classList && e.target.classList.contains('fc')) root = e.target;
    if (root) initSection(root);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.fc[data-section-id]') : null;
    if (root) initSection(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();

			if (this.headerIsAlwaysSticky) this.reveal;
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			if (this.header) {
				observer.observe(this.header);
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
			};

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky');
			};

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
					this.predictiveSearch.onFocusOut();
					this.predictiveSearch.onBlur();
				}
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => disclosure.close());
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industries-served"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('industries-rail')) return;

    class IndustriesRail extends HTMLElement {
      #ticking = false;
      #observer = null;

      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.rail) return;

        this.rail.addEventListener('scroll', this.#onScroll, { passive: true });
        this.#observer = new ResizeObserver(this.#update);
        this.#observer.observe(this.rail);

        if (this.prev && this.next) {
          this.prev.hidden = false;
          this.next.hidden = false;
          this.prev.addEventListener('click', () => this.#page(-1));
          this.next.addEventListener('click', () => this.#page(1));
        }

        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', this.#onBlockSelect);
        }

        this.#update();
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        document.removeEventListener('shopify:block:select', this.#onBlockSelect);
      }

      /** @param {1 | -1} direction */
      #page(direction) {
        const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollBy({
          left: direction * rtl * this.rail.clientWidth * 0.8,
          behavior: reduce ? 'auto' : 'smooth',
        });
      }

      #onScroll = () => {
        if (this.#ticking) return;
        this.#ticking = true;
        requestAnimationFrame(() => {
          this.#ticking = false;
          this.#update();
        });
      };

      #update = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const position = Math.abs(this.rail.scrollLeft);
        this.toggleAttribute('data-scrollable', max > 1);
        if (!this.prev || !this.next) return;
        this.prev.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
      };

      #onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };
    }

    customElements.define('industries-rail', IndustriesRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-features"] && !Shopify.designMode) return;
  try {
    
  class KeyFeatures extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.key-features__list');
      this.toggle = this.querySelector('.key-features__toggle--button');
      this.showMoreText = this.querySelector('.key-features__show-more');
      this.showLessText = this.querySelector('.key-features__show-less');
      this.initialCount = parseInt(this.list?.dataset.initialCount) || 3;
      this.isExpanded = false;
      this.features = Array.from(this.list?.querySelectorAll('.key-features__feature') || []);
      if (this.toggle) {
        this.hideExtraFeatures();
        this.toggle.addEventListener('click', () => this.toggleFeatures());
      }

      // Freeze the staggered entrance after first paint completes
      const sectionEl = this.closest('[id^="key-features-"]');
      if (sectionEl) {
        setTimeout(() => sectionEl.setAttribute('data-kf-animated', 'done'), 1200);
      }
    }

    hideExtraFeatures() {
      this.features.forEach((feature, index) => {
        feature.style.display = (index < this.initialCount) ? 'list-item' : 'none';
        feature.classList.remove('kf-revealed');
      });
      if (this.toggle) this.toggle.setAttribute('data-kf-expanded', 'false');
    }

    toggleFeatures() {
      if (this.isExpanded) {
        this.hideExtraFeatures();
        if (this.showMoreText) this.showMoreText.style.display = 'inline';
        if (this.showLessText) this.showLessText.style.display = 'none';
      } else {
        this.features.forEach((feature, index) => {
          feature.style.display = 'list-item';
          if (index >= this.initialCount) {
            // Stagger fresh entrance for newly-revealed items
            feature.classList.remove('kf-revealed');
            // Force reflow so the animation replays
            void feature.offsetWidth;
            feature.style.animationDelay = ((index - this.initialCount) * 60) + 'ms';
            feature.classList.add('kf-revealed');
          }
        });
        if (this.showMoreText) this.showMoreText.style.display = 'none';
        if (this.showLessText) this.showLessText.style.display = 'inline';
        if (this.toggle) this.toggle.setAttribute('data-kf-expanded', 'true');
      }
      this.isExpanded = !this.isExpanded;
    }
  }

  customElements.define('key-features', KeyFeatures);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class RelatedProduct extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const related = html.querySelector('.related-product');
            if (related && related.innerHTML.trim().length) {
              this.innerHTML = related.innerHTML;
            }

            /* Toggle content */
            $('.product-description-more').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-short').next().show();
              $(this).closest('.product-description-short').hide();
            });

            $('.product-description-less').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-full').prev().show();
              $(this).closest('.product-description-full').hide();
            });
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  class RelatedSlider extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
            if (relatedSlider && relatedSlider.innerHTML.trim().length) {
              this.innerHTML = relatedSlider.innerHTML;
            }

            /* Related products slider */
            const slider = this.querySelector('.related-slider__list');
            const prevBtn = this.querySelector('.related-slider__button-prev');
            const nextBtn = this.querySelector('.related-slider__button-next');
            const twoColumns = this.querySelector('.swiper-wrapper-2-mobile');
            if (twoColumns && document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            } else if (document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                { duration: 200, easing: 'ease-in', fill: 'forwards' }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('related-product', RelatedProduct);
  customElements.define('related-slider', RelatedSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            const recommendationCount = recommendations
              ? Number(recommendations.dataset.recommendationsCount || 0)
              : 0;
            if (
              recommendations &&
              recommendationCount > 0 &&
              recommendations.querySelector('.product-recommendations__product')
            ) {
              this.innerHTML = recommendations.innerHTML;
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector(".media--first");
                    const secondaryImage = wrapper.querySelector(".media--second");
                    const handleProduct = wrapper.dataset.product;
                    
                    if (event.currentTarget.checked && primaryImage) {
                      wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
                        wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
                        wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
                      }
                      
                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
                        const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                          
                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              } 
                            }
                            if (flag == false) {
                              primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                              setTimeout(function(){
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                                if (secondaryImage) {
                                  secondaryImage.remove();                                    
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  })
                })
              })
            }

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sealmaster-food-beverage-solution"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sealmaster-stat-counter')) {
    class SealmasterStatCounter extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.display = this.querySelector('[data-counter-display]');
        this.finalText = this.dataset.value || '';
        this.target = Number(this.finalText.replace(/[^0-9.-]/g, ''));

        if (!this.display || Number.isNaN(this.target)) return;

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.#animate();
              this.observer.disconnect();
            }
          }
        }, { threshold: 0.4 });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      #animate() {
        const duration = 1200;
        const start = performance.now();

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = Math.round(this.target * eased);
          this.display.textContent = current.toLocaleString();

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            this.display.textContent = this.finalText;
          }
        };

        requestAnimationFrame(step);
      }
    }

    customElements.define('sealmaster-stat-counter', SealmasterStatCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skf-bearings-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skf-stat-counter')) {
    class SkfStatCounter extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.display = this.querySelector('[data-counter-display]');
        this.finalText = this.dataset.value || '';
        this.target = Number(this.finalText.replace(/[^0-9.-]/g, ''));

        if (!this.display || Number.isNaN(this.target)) return;

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.#animate();
              this.observer.disconnect();
            }
          }
        }, { threshold: 0.4 });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      #animate() {
        const duration = 1200;
        const start = performance.now();

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = Math.round(this.target * eased);
          this.display.textContent = current.toLocaleString();

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            this.display.textContent = this.finalText;
          }
        };

        requestAnimationFrame(step);
      }
    }

    customElements.define('skf-stat-counter', SkfStatCounter);
  }

  } catch(e) { console.error(e); }
})();
})();
